<template>
  <div class="">
    <v-select
      v-model="supplierList"
      :options="supplierOptions"
      :clearable="false"
      @input="onChange"
      @search="onSearch"
      :disabled="isSelectDisabled"
      append-to-body
    />
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from "@vue/composition-api";
import { BSpinner } from 'bootstrap-vue'
import vSelect from "vue-select";
import {debounce} from "lodash";
import axios from "@axios";

export default {
  components: {
    BSpinner,
    vSelect
  },
  props: {
    id: String,
    name: String,
    label: String,
    fieldOptions: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    field: {
      type: Object,
      default: () => ({}),
    },
    isFormDisabled: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    isHorizontal: {
      type: Boolean,
      default: true
    }
  },
  setup(props, { emit }) {
    const search = ref("");
    const limit = ref(8);
    const supplierList = ref(false);
    const options = ref(null);
    const isSelectDisabled = ref(false);
    const supplierOptions = computed(() =>
      (options.value || []).map(u => ({
        value: u.id,
        label: u.name,
      }))
    );

    onMounted(() => {
      isSelectDisabled.value = props.isFormDisabled ?? false;
      fetchData()
    });

    watch(
      () => props.isFormDisabled,
      (newValue, oldValue) => {
        isSelectDisabled.value = props.isFormDisabled;
      },
      { immediate: true }
    );

    async function fetchData() {
      try {
        const {data} = await axios.get("/v1/companies", {
          params: {
            q: search.value,
            max: limit.value,
            sortBy: 'id',
          },
        });
        options.value = data.data;
      } catch (error) {
        console.error(`Supplier: request error`, error?.response || error);
      }
    }

    async function onChange(value) {
      emit("updateData", props.field, supplierList.value);
    }


    const onSearch = debounce(async (query, loading) => {
      if (query && query.length) {
        loading(true);
        search.value = query;
        await fetchData();
        loading(false);
      } else {
        search.value = '';
        await fetchData();
      }
    }, 500);

    return {
      supplierList,
      supplierOptions,
      isSelectDisabled,
      onSearch,
      onChange
    }
  }
}
</script>